import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { useTrackVisibility } from "react-intersection-observer-hook";

import { useState, useEffect } from "react";
import { SvgArrowTop } from "@/assets/icons";
const { useBreakpoint } = Grid;

export function FAGSAskedQuestions({ questions = {} }) {
	const screens = useBreakpoint();
	const [ref, { isVisible }] = useTrackVisibility();
	const { question_list = [], title = "" } = questions;
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setVisible(true);
		}
	}, [isVisible]);
	return (
		<Container ref={ref}>
			<Row justify="center">
				<Col md={24} className={`${visible && "animate__animated animate__fadeInDown"}`}>
					<WrapperContent>
						<RATypography variant={screens?.xs ? "h4" : "h2"} align="center">
							{title || ""}
						</RATypography>
					</WrapperContent>
				</Col>
			</Row>
			<WrapperSection>
				<Row gutter={[20, 20]}>
					{question_list?.length > 0
						? question_list?.map((item = {}, index) => {
								return (
									<Col
										span={24}
										className={`${isVisible && "animate__animated animate__zoomIn"}`}
										key={`faqs-asked-question-${index}`}
									>
										<CardQuestionItem question={item?.question} answer={item?.answer} />
									</Col>
								);
							})
						: null}
				</Row>
			</WrapperSection>
		</Container>
	);
}

const CardQuestionItem = ({ question = "", answer = "" }) => {
	const [showAnswer, setShowAnswer] = useState(false);
	return (
		<WrapperCard>
			<Row
				style={{
					display: "flex",
					flexWrap: "nowrap",
					cursor: "pointer",
				}}
				gutter={[6, 4]}
				justify="space-between"
				onClick={() => setShowAnswer(!showAnswer)}
			>
				<Col>
					<RATypography variant="sub-heading3">{question}</RATypography>
				</Col>
				<Col>
					<div
						style={{
							transition: "transform 0.3s",
							transform: showAnswer ? `rotate(0turn)` : "rotate(0.5turn)",
						}}
					>
						<SvgArrowTop />
					</div>
				</Col>
			</Row>
			{showAnswer ? (
				<Row>
					<Col span={24}>
						<RATypography variant="body3" color="#595959">
							{answer}
						</RATypography>
					</Col>
				</Row>
			) : null}
		</WrapperCard>
	);
};

const Container = styled.div`
	width: 100%;
	height: 100%;
`;
const WrapperContent = styled.div`
	flex-direction: column;
	align-items: center;
`;
const WrapperSection = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 24px;
`;
const WrapperCard = styled.div`
	display: flex;
	width: 100%;
	padding: 16px;
	border-radius: 12px;
	border: 1px solid var(--bg-500-line, #e9e8e8);
	background: #fff;
	display: flex;
	flex-direction: column;
	gap: 12px;
`;
